import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from '../../../../../components/button/index';
import { popupStore } from '../../popup/popup.store';
import { PopupType } from '../../popup/popup.types';
import { formStore, PerkFormMode } from '../form.store';

export type FormControlButtonsProps = {
  disabled?: boolean;
  handleNext: () => void;
  handlePrev: () => void;
  isPending?: boolean;
  onFinalStep?: boolean;
  onFirstStep?: boolean;
};

export const FormControlButtons: FC<FormControlButtonsProps> = ({
  handleNext,
  handlePrev,
  onFirstStep,
  isPending,
  disabled,
  onFinalStep,
}) => {
  const mode = formStore(({ formMode }) => formMode);
  const close = formStore(({ close }) => close);

  const openPopup = popupStore(({ openPopup }) => openPopup);

  const submitTranslationKey: PartialRecord<PerkFormMode, string> = {
    [PerkFormMode.CREATE]: onFinalStep ? 'Add Perk' : 'Next',
    [PerkFormMode.EDIT]: 'Save',
    [PerkFormMode.VIEW]: 'Close',
  };

  return (
    <div
      className={twMerge(
        'flex w-full items-center justify-between py-4',
        mode === PerkFormMode.VIEW && 'justify-end',
      )}
    >
      {mode !== PerkFormMode.VIEW && (
        <Button
          className="text-sm font-[450] text-gray-700"
          onClick={() =>
            openPopup({
              onAcceptCallback: close,
              type:
                mode === PerkFormMode.CREATE
                  ? PopupType.CANCEL_PERK_CREATION
                  : PopupType.CANCEL_PERK_EDITING,
            })
          }
          styleType="DEFAULT_ROUNDED"
        >
          Cancel
        </Button>
      )}
      <div className="flex gap-3">
        {!onFirstStep && (
          <Button
            className="w-fit border border-gray-300 bg-gray-25 px-4 py-[10px] text-gray-700"
            isLoading={isPending}
            onClick={handlePrev}
            role="button"
          >
            Back
          </Button>
        )}

        <Button
          className="w-fit px-4 py-[10px]"
          disabled={disabled}
          isLoading={isPending}
          onClick={handleNext}
          role="button"
        >
          {submitTranslationKey[mode]}
        </Button>
      </div>
    </div>
  );
};
